export enum ColorMode {
  Color = "color",
  Grayscale = "grayscale",
  Presets = "presets",
}

export enum OutputFormat {
  Auto = "auto",
  Hex = "hex",
  Rgba = "rgba",
  Hsla = "hsla",
}

export enum AlphaChannel {
  Enabled = "enabled",
  Disabled = "disabled",
  Always = "always",
  Forced = "forced",
}

export enum PositionDialog {
  Auto = "auto",
  Top = "top",
  Bottom = "bottom",
  Left = "left",
  Right = "right",
}

export enum DialogDisplay {
  Popup = "popup",
  Inline = "inline",
}
